/**
 * The icon files `@trabeate/design-system` ships under `assets/brand/`, served at the site root
 * under the same names (REQ-LANDING-013). The design system's brand README makes these names and
 * that folder the contract: a new mark changes the files' contents, never a name.
 *
 * Read by `vite.config.ts`, which copies them, by `app/root.tsx`, which declares them, and by
 * `tests/brand-icons.test.ts`.
 */
export const BRAND_ICONS = {
  /** 16, 32 and 48 px, for a browser that cannot use the SVG, and the host's root request. */
  ico: 'favicon.ico',
  /** Scalable; preferred wherever SVG icons are supported. */
  svg: 'favicon.svg',
  /** 180 × 180, opaque, for a link saved to a device's home screen. */
  appleTouch: 'apple-touch-icon.png',
} as const;

/** Where the design system keeps them, relative to its package root. */
export const BRAND_ASSET_DIR = 'assets/brand';
